import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';
import { User } from 'src/app/beans/login/user/user.bean';

@Injectable({
  providedIn: 'root'
})
export class UserSession implements Session
{
    constructor() { }

    get(): User | SessionCode
    {
        try{
            const user_json = localStorage.getItem( SessionKey.USER ) 

            if (!user_json) return SessionCode.MISSING_VALUE

            const json = JSON.parse( user_json )

            if (User.isKind (json) ) 
                return json as User
            else
                return SessionCode.PARSING
            
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set( user : User ): SessionCode
    {
        if(!User.isKind (user)) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.USER, JSON.stringify(user) ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.USER ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

